module.exports = __webpack_public_path__ + "static/img/s-oppo-2.308cb7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-oppo-2.png
// module id = 0Ep4
// module chunks = 1